var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"select-work-day"}},[_c('van-picker',{attrs:{"show-toolbar":"","title":_vm.title,"columns":_vm.columns,"default-index":_vm.ini},on:{"confirm":_vm.getConfirmPickerObj}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }